import api from "./api";
import Empresa from "../types/negocio/Empresa";
import BaseService from "./BaseService";
import { FundamentosGenerationRequest, FundamentosGenerationResponse } from "../types/fundamentos/FundamentosTypes";

class EmpresaService extends BaseService<Empresa> {
  
  constructor() {
    super('empresa', api);
  }

  async getEmpresa(): Promise<Empresa> {
    return (await this.api.get(`/api/${this.route}/me`)).data;
  }

  async gerarFundamentos(request: FundamentosGenerationRequest): Promise<FundamentosGenerationResponse> {
    return (await this.api.post(`/api/${this.route}/gerar-fundamentos`, request)).data;
  }
    
}

export const empresaService = new EmpresaService();